import { useRecoilValue } from "recoil";
import { getNextLabel, getProgressPercentage } from "selectors/controller";
import { appStrings } from "utils/appStrings";
import ArrowRight from "components/Icons/ArrowRight";
import Check from "components/Icons/Check";
import { StepTypes } from "models/controller";
import { stepTypeState } from "atoms/controller";
import ArrowLeft from "components/Icons/ArrowLeft";
import { toNumber } from "lodash";

export interface QuizFooterProps {
  loading: boolean;
  next: () => void;
  back: (() => void) | undefined;
}

const QuizFooter: React.FC<QuizFooterProps> = ({ loading, next, back }) => {
  const nextLabel: string = useRecoilValue(getNextLabel);
  const progressPercentage: string = useRecoilValue(getProgressPercentage);
  const currentStepType: StepTypes = useRecoilValue(stepTypeState);
  const scaleValue: number = toNumber(progressPercentage) / 100;

  return (
    <div
      className={`bg-white relative py-4 px-8 flex flex-wrap items-center text-center ${
        back ? "justify-between" : "justify-end"
      } dark:bg-gray-800`}
    >
      <div
        className="absolute inline-block right-0 h-full w-full z-10 bg-gradient-to-l from-ghBlue to-ghPurple transition duration-300 "
        style={{
          transform: `scalex(${scaleValue})`,
          WebkitTransform: `scalex(${scaleValue})`,
          transformOrigin: "100% 50%",
        }}
      ></div>
      {back && (
        <button onClick={back} className="z-20">
          <ArrowRight />
        </button>
      )}
      <button
        onClick={next}
        className="text-primary-600 font-semibold py-1 px-8 rounded-xl flex flex-row items-center z-20 focus:outline-none dark:text-white"
      >
        {loading ? appStrings.loading : nextLabel}
        <span className="mr-2" style={{ rotate: "0deg" }}>
          {currentStepType === StepTypes.PROBLEM ? <Check /> : <ArrowLeft />}
        </span>
      </button>
    </div>
  );
};

export default QuizFooter;
